export function getUrlWithQueryString(baseUrl: string, data?: Record<string, string>): string {
  if (!data) {
    return baseUrl;
  }
  const components = Object.entries(data).map(
    ([key, value]): string => `${encodeURIComponent(key)}=${encodeURIComponent(value)}`
  );
  return `${baseUrl}?${components.join('&')}`;
}
